import { defineMessages } from "react-intl";

export const analyticsMessages = defineMessages({
  // Sections
  sectionRevenue: {
    id: 'kbkaw8',
    defaultMessage: "Revenue & Sales Performance",
  },
  sectionOrders: {
    id: 'qgCxnt',
    defaultMessage: "Orders & Checkout",
  },
  sectionCustomers: {
    id: 'QQPipA',
    defaultMessage: "Customers & Retention",
  },
  sectionInventory: {
    id: 'LN+l0X',
    defaultMessage: "Inventory & Merchandising",
  },
  sectionFulfillment: {
    id: '9RKXhW',
    defaultMessage: "Fulfillment & Ops",
  },

  // Preset labels
  presetLast7d: {
    id: 'irFBKn',
    defaultMessage: "Last 7 days",
  },
  presetLast30d: {
    id: 'Rfvi9/',
    defaultMessage: "Last 30 days",
  },
  presetLast90d: {
    id: 'mgYBYo',
    defaultMessage: "Last 90 days",
  },

  // Revenue & Sales Performance
  totalSalesGMV: {
    id: 'QVOq6V',
    defaultMessage: "Total Sales (GMV)",
  },
  netSales: {
    id: 'Fm/UL9',
    defaultMessage: "Net Sales",
  },
  avgOrderValue: {
    id: 'EJ42bl',
    defaultMessage: "Avg Order Value",
  },
  avgItemsPerOrder: {
    id: 'D/U7hT',
    defaultMessage: "Avg Items / Order",
  },
  grossSalesDailyTrend: {
    id: 'YQO2g4',
    defaultMessage: "Gross Sales (daily trend)",
  },
  bestSellersTopN: {
    id: 'PnrjOb',
    defaultMessage: "Top SKUs by Units (Top {topN})",
  },
  topSkusByRevenue: {
    id: '4NrzXn',
    defaultMessage: "Top SKUs by Revenue (Top {topN})",
  },
  salesByChannelCurrency: {
    id: 'v0b2Gb',
    defaultMessage: "Sales by Channel/Currency",
  },
  salesByCategory: {
    id: 'R8szsL',
    defaultMessage: "Sales by Category",
  },
  channelPerformance: {
    id: 'XiZPbw',
    defaultMessage: "Channel Performance",
  },
  colAov: {
    id: 'sEHR7/',
    defaultMessage: "AOV",
  },
  colShare: {
    id: 'OKhRC6',
    defaultMessage: "Share",
  },

  // Orders & Checkout
  totalOrders: {
    id: 'mJT+7o',
    defaultMessage: "Total Orders",
  },
  ordersByStatus: {
    id: 'fYfeuH',
    defaultMessage: "Orders by Status",
  },
  cancellations: {
    id: 'miRBM1',
    defaultMessage: "Cancellations",
  },
  discountImpact: {
    id: '191Bh4',
    defaultMessage: "Discount Impact",
  },
  vouchers: {
    id: 'etP0+D',
    defaultMessage: "Vouchers",
  },
  giftCards: {
    id: 'F9lEk2',
    defaultMessage: "Gift Cards",
  },

  // Customers & Retention
  topCustomers: {
    id: 'ZjkOGL',
    defaultMessage: "Top Customers",
  },
  repeatPurchaseRate: {
    id: 'XzH3Vm',
    defaultMessage: "Repeat Purchase Rate",
  },
  timeToSecondOrder: {
    id: 'Q7CBHh',
    defaultMessage: "Time to 2nd Order",
  },
  churnRisk: {
    id: 'TFvh9p',
    defaultMessage: "Churn Risk",
  },

  // Inventory & Merchandising
  lowStockThreshold: {
    id: 'KyQxki',
    defaultMessage: "Low-Stock (threshold)",
  },
  lowStockAlertsTopN: {
    id: 'L85WG3',
    defaultMessage: "Low-stock Alerts (Top {topN})",
  },
  outOfStockSkus: {
    id: 'KSopz7',
    defaultMessage: "Out-of-Stock SKUs",
  },
  daysOfInventoryOnHand: {
    id: 'f6RPP0',
    defaultMessage: "Days of Inventory on Hand (DOH)",
  },
  deadStock: {
    id: 'F3Whhi',
    defaultMessage: "Dead Stock (no sales in range)",
  },

  // Fulfillment & Ops
  avgTimeToFulfill: {
    id: '1UU6LY',
    defaultMessage: "Avg Time to Fulfill",
  },
  onTimeFulfillmentRateWithSla: {
    id: 'f+OeLB',
    defaultMessage: "On-time Fulfillment Rate (≤ {slaHours}h)",
  },
  refundReturnRate: {
    id: '0gFYYP',
    defaultMessage: "Refund / Return Rate",
  },
  shippingMargin: {
    id: 'cABRlf',
    defaultMessage: "Shipping Margin",
  },

  // Column headers
  colProduct: {
    id: 'x/ZVlU',
    defaultMessage: "Product",
  },
  colUnits: {
    id: 'A1ykkc',
    defaultMessage: "Units",
  },
  colGmv: {
    id: 'ARIlGw',
    defaultMessage: "GMV",
  },
  colChannel: {
    id: 'KeO51o',
    defaultMessage: "Channel",
  },
  colCurrency: {
    id: '55hdQy',
    defaultMessage: "Currency",
  },
  colCategory: {
    id: 'ccXLVi',
    defaultMessage: "Category",
  },
  colStatus: {
    id: 'tzMNF3',
    defaultMessage: "Status",
  },
  colCount: {
    id: 'Aujn2T',
    defaultMessage: "Count",
  },
  colType: {
    id: '+U6ozc',
    defaultMessage: "Type",
  },
  colAmount: {
    id: '/0TOL5',
    defaultMessage: "Amount",
  },
  colCustomer: {
    id: 'hkENym',
    defaultMessage: "Customer",
  },
  colOrders: {
    id: 'X7jl6w',
    defaultMessage: "Orders",
  },
  colVariant: {
    id: 'OK5+Fh',
    defaultMessage: "Variant",
  },
  colAvailable: {
    id: 'PgJGHT',
    defaultMessage: "Available",
  },
  colSku: {
    id: 'k4brJy',
    defaultMessage: "SKU",
  },
  colDays: {
    id: 'd8EqQY',
    defaultMessage: "Days",
  },
  // Common labels
  commonLoading: {
    id: 'T4VxQN',
    defaultMessage: "Loading…",
  },
  commonNoData: {
    id: 'UG5qoS',
    defaultMessage: "No data",
  },
  commonNA: {
    id: 'PW+sL4',
    defaultMessage: "N/A",
  },
  unitDays: {
    id: 'Bc20la',
    defaultMessage: "days",
  },
  unitUnits: {
    id: 'Vl9vDx',
    defaultMessage: "units",
  },
});
